'use strict';

$ = jQuery;

/*
* Evento de clique no breadcrumb
*/
$('#crumbs a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Breadcrumb',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Breadcrumb',
    'eventLabel': $(this).text()
  });
});